import { ConsentPreferences } from "./types";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
    fbq: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue: unknown[];
      loaded: boolean;
      version: string;
    };
  }
}

/**
 * Updates Google Consent Mode based on user preferences
 */
export const updateGoogleConsentMode = (preferences: ConsentPreferences): void => {
  if (typeof window === "undefined") return;

  // Ensure gtag is available
  if (typeof window.gtag !== "function") {
    // Initialize gtag if not available
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  window.gtag("consent", "update", {
    analytics_storage: preferences.analytics ? "granted" : "denied",
    ad_storage: preferences.advertising ? "granted" : "denied",
    ad_user_data: preferences.advertising ? "granted" : "denied",
    ad_personalization: "denied",
  });
};

/**
 * Loads Meta Pixel script dynamically if advertising consent is given
 */
export const loadMetaPixel = (pixelId: string | undefined): void => {
  if (typeof window === "undefined" || !pixelId) return;

  // Check if already loaded
  if (window.fbq) return;

  // Initialize fbq
  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue.push(args);
    }
  } as Window["fbq"];

  window.fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];

  // Load the script
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  const firstScript = document.getElementsByTagName("script")[0];
  firstScript?.parentNode?.insertBefore(script, firstScript);

  // Initialize with pixel ID
  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
};
